import { Abonent } from '@shared/types/osi/abonents';

export interface IOsiAccrualsByAbonentViewModel {
  isLoading: boolean;
  abonents: Abonent[];
  selectedAbonent: Abonent | null;
  rows: any[];
  dateValue: any;
  // Флаг схлопывания дочерних помещений
  isCollapseChildren: boolean;
  // Список помещений для выпадающего списка с учётом флага схлопывания
  visibleAbonents: Abonent[];
  // OSI-806: есть ли у ОСИ дочерние помещения (паркинги/кладовки).
  // Если нет — чекбокс «Свернуть дочерние помещения» не показываем.
  hasChildAbonents: boolean;
  loadAbonents: () => Promise<void>;
  loadAccruals: () => Promise<void>;
  // Переключение флага схлопывания дочерних помещений
  setCollapseChildren: (value: boolean) => void;
}

export const IOsiAccrualsByAbonentViewModelToken = Symbol.for('IOsiAccrualsByAbonentViewModel');
